import RoutesInterface from './RoutesInterface';
import { getServices } from '../../../infra/startup';
import { RoutesInterfaceType, RouteType } from '@clientos/types';
import { internalLogger } from '../clientOsLogger';

let routesInterface: RoutesInterface;

export function getRoutesInterface(): RoutesInterface {
  return routesInterface;
}

export default async function initializeRoutesInterface(): Promise<RoutesInterfaceType> {
  if (routesInterface) return routesInterface.getInterface();

  const services = getServices();
  const { routesService } = services;

  routesInterface = new RoutesInterface({ routesService });

  return routesInterface.getInterface();
}

export function createNoopRoutesInterface(): RoutesInterfaceType {
  return {
    getRoutes: function (): RouteType[] {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'createNoopRoutesInterface',
        methodName: 'getRoutes()',
        message: 'Noop interface method called - returning empty array'
      });
      return [];
    },
    findRouteByKey: function (): RouteType {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'createNoopRoutesInterface',
        methodName: 'findRouteByKey()',
        message: 'Noop interface method called - returning empty object'
      });
      return {};
    },
    findRouteByPath: function (): RouteType {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'createNoopRoutesInterface',
        methodName: 'findRouteByPath()',
        message: 'Noop interface method called - returning empty object'
      });
      return {};
    }
  };
}
